<template>
  <div id="login-page">
      <div id="icon-container">
        <v-icon size="150" color="#ffffff">
          $icon_logo
        </v-icon>
      </div>

      <div class="login-form-div">
        <v-form v-model="form_valid" class="login-form">
              <v-text-field
                :label="$i18n.t('pages.login.username')"
                name="username"
                prepend-inner-icon="mdi-account"
                type="text"
                v-model="username"
                :rules="username_rules"
                required
                outlined
                class="login-textfield rounded_8px"
                background-color="#FFFFFF"
              ></v-text-field>

              <v-text-field
                id="password"
                :label="$i18n.t('pages.login.password')"
                name="password"
                prepend-inner-icon="mdi-lock"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="password_field_type"
                v-model="password"
                :rules="password_rules"
                required
                outlined
                class="login-textfield rounded_8px"
                background-color="#FFFFFF"
                @click:append="show_password = !show_password"
              >
              </v-text-field>
              <div style="min-width: 400px; display: flex; justify-content: space-between">
                <v-btn
                    @click="sign_in(username, password)"
                    color="#207ea9"
                    class="white--text login-button"
                    min-height="50px"
                    width="72%"
                    height="56px"
                    elevation="0"
                    style="border-radius: 8px"
                >
                  {{ $i18n.t('pages.login.log_in') }}
                </v-btn>
                <locale-switcher
                    :width="'100px'"
                    :locales="supported_locales_short"
                />
              </div>
        </v-form>
      </div>
  </div>
</template>

<script>
import router from "@/router";
import {mapActions, } from "vuex";
import {i18n} from "@/i18n";
import store from "@/store";
import LocaleSwitcher from "@/components/LocaleSwitcher";
import {getSupportedLocalesCodes} from "../utils/supported-locales";

export default {
  components: {LocaleSwitcher},
  data: function () {
    return {
      form_valid: true,
      username: '',
      password: '',
      show_password: false,
      username_rules: [
        v => !!v || i18n.t('validation.this_field_is_required'),
        v => v.length >= 5 || i18n.t('validation.username_too_short'),
      ],
      password_rules: [
         v => !!v || i18n.t('validation.this_field_is_required'),
      ]
    }
  },
  methods: {
    sign_in: function (username, password) {
      let t = this
      if ((username === '') || (password === '')) return
      let data = {'user': {'username': username, 'password': password}}
      this.$http({url: this.$http_hostname + '/users/sign_in', data: data, method: 'POST'})
      .then(resp => {
        let data = resp.data
        data.user.logged_in = true
        t.changeUserData(data.user)
        router.push(t.$i18nRoute({name: 'RecognitionJournal'}))
      })
      .catch(error => {
        t.$store.state.user.logged_in = false
        t.show_error_message(error)
      })
    },

    show_error_message: function (error) {
        let section = error.response.data.section
        let message = error.response.data.message
        if (!section || !message) {
          this.setSnackbar({
            text: i18n.t(`notifications.security.error_during_login`),
          })
        } else {
          this.setSnackbar({
          text: i18n.t(`notifications.${section}.${message}`),
          })
        }
      },
    ...mapActions(['changeUserData', 'setSnackbar'])
  },
  mounted() {
    console.log(store.getters.isLoggedIn)
    if (store.getters.isLoggedIn === true) {
      router.push(this.$i18nRoute({name: 'RecognitionJournal'}))
    }
  },
  computed: {
    password_field_type: function () {
      return this.show_password ? 'text' : 'password'
    },
    supported_locales_short: function () {
      return getSupportedLocalesCodes()
    }
  }
}
</script>

<style lang="scss" scoped>
.login-form-div {
  position: absolute;
  width: 400px;
  margin-top: 100px;
}
.login-textfield >>> .v-input__slot{
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 8px;
  height: 20px;
}
.login-button {
  border-radius: 4px;
}
.login-form {
  position: center;
}
#icon-container {
  position: absolute;
  display: flex;
  justify-content: center;
  top: 15%
}

#login-page {
  width: 100%;
  height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>